type FeedbackRequest = {
  type: 'issue' | 'feature_request' | 'general';
  subject: string;
  message: string;
};

type ContextualFeedbackRequest = {
  type: 'like' | 'dislike' | 'suggestion' | 'issue' | 'feature_request' | 'general';
  subject: string;
  message: string;
  context: {
    type: 'meal_plan' | 'assignment' | 'quick_bite';
    mealPlanId?: string;
    assignmentId?: string;
    recipeName?: string;
    recipeId?: string;
  };
};

type FeedbackResponse = {
  message: string;
  ticketId: string;
};

export const submitFeedback = async (
  feedback: FeedbackRequest,
  userToken: string
): Promise<FeedbackResponse> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/support/feedback`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify(feedback),
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Request failed: ${response.status}`);
  }

  return await response.json();
};

export const submitContextualFeedback = async (
  feedback: ContextualFeedbackRequest,
  userToken: string
): Promise<FeedbackResponse> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/support/feedback`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify(feedback),
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Request failed: ${response.status}`);
  }

  return await response.json();
};